var map = {
	"./autocorrelation.json": 65,
	"./autocorrelation_test.json": 66,
	"./clustering.json": 67,
	"./forecasting.json": 68,
	"./frequent_pattern.json": 69,
	"./multivariate_distribution.json": 70,
	"./multivariate_outlier.json": 71,
	"./origin.json": 45,
	"./origin_back.json": 72,
	"./outstanding.json": 73,
	"./seasonality.json": 74,
	"./similarity.json": 75,
	"./template.json": 76,
	"./trend.json": 77,
	"./univariate_distribution.json": 78,
	"./univariate_outlier.json": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;